// extracted by mini-css-extract-plugin
export default {"section":"SkillsSection_section__A7tjJ"};